export const ADD_APPLICANT_TIME_SHEET = "ADD_APPLICANT_TIME_SHEET";
export const GET_APPLICANTS_WORKING_SLOTS_REQUEST =
  "GET_APPLICANTS_WORKING_SLOTS_REQUEST";

export const GET_APPLICANTS_WORKING_SLOTS_RESPONSE =
  "GET_APPLICANTS_WORKING_SLOTS_RESPONSE";
export const EDIT_APPLICANT_SHEET_REQUEST = "EDIT_APPLICANT_SHEET_REQUEST";
export const EDIT_APPLICANT_SHEET_RESPONSE = "EDIT_APPLICANT_SHEET_RESPONSE";
export const DELETE_APPLICANT_SHEET_REQUEST = "DELETE_APPLICANT_SHEET_REQUEST";
